import { api } from "@lib/orpc-client";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";

export type ExchangeRateResponse = {
  uuid: string;
  ex_rate: string;
  inverse_rate: string;
  size: string;
  total: string;
  fees: {
    network_fee: number;
    income_tax: number;
    vat: number;
    total_fees: number;
  };
  valid_time: number;
};

type Mode = "variable-jidr" | "fixed-jidr" | undefined | null;

const useExchangeRate = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function getExchangeRate(
    assetId: string
  ): Promise<ExchangeRateResponse>;
  async function getExchangeRate(
    assetId: string,
    amount: string,
    mode: "variable-jidr" | "fixed-jidr"
  ): Promise<ExchangeRateResponse>;
  async function getExchangeRate(
    assetId: string,
    amount?: string,
    mode?: Mode
  ): Promise<ExchangeRateResponse> {
    try {
      setError(null);
      setIsLoading(true);
      let params: {
        from_asset: string;
        to_asset: string;
        from_amount?: string;
        to_amount?: string;
      };
      switch (mode) {
        case "variable-jidr":
          params = {
            from_asset: assetId,
            to_asset: "JIDR",
            from_amount: amount,
          };
          break;
        case "fixed-jidr":
          params = { from_asset: assetId, to_asset: "JIDR", to_amount: amount };
          break;
        default:
          params = { from_asset: assetId, to_asset: "JIDR", from_amount: "1" };
      }
      return await api.wallet.exchangeRate(params);
    } catch (error) {
      Sentry.captureException(error);
      setError(t("errors.1006.description"));
      throw error;
    } finally {
      setIsLoading(false);
    }
  }

  return {
    getExchangeRate,
    isLoading,
    error,
  };
};

export default useExchangeRate;
